/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection14FoiChanged, m11ReportSection14ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection14Foi, selectM11ReportSection14Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveReferencesChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section14State, setAlertModalState, setStartingSection14State) => {

    let changesStates = {
        section14State: section14State
    };
    let response = await saveM11Changes(apiToken, 40, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection14Resource) {
            dispatch(m11ReportSection14ResourceChanged(response.m11ReportSection14Resource));
        }
        setStartingSection14State(JSON.parse(JSON.stringify(section14State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step040References = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection14Foi = useSelector(selectM11ReportSection14Foi);
    const m11ReportSection14Resource = useSelector(selectM11ReportSection14Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section14State, setSection14State] = useState({
        "section14Status": "empty", "section14Xhtml": ""
    });
    const [startingSection14State, setStartingSection14State] = useState({
        "section14Status": "empty", "section14Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section14State, startingSection14State)),
        async saveAllChanges() {
            await saveReferencesChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section14State, setAlertModalState, setStartingSection14State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section14Status": "empty", "section14Xhtml": "", "loaded": true
            };
            setSection14State(startingData);
            setStartingSection14State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[14]?.entry?.length) {
                let m11ReportSection014Foi = getIdFromReference(m11ReportContainerResource.section[14].entry[0]);
                if (m11ReportSection014Foi && !isNaN(m11ReportSection014Foi) &&
                    m11ReportSection014Foi !== m11ReportSection14Foi) {
                    dispatch(m11ReportSection14FoiChanged(m11ReportSection014Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection14Foi && !isNaN(m11ReportSection14Foi)) {
            loadResource(m11ReportSection14Foi, "M11ReportSection14", apiToken, dispatch);
        }
    }, [m11ReportSection14Foi]);

    useEffect(() => {
        if (m11ReportSection14Resource && Object.keys(m11ReportSection14Resource).length > 0) {
            let startingData = {
                "section14Status": "empty", "section14Xhtml": "", "loaded": true
            };
            if (m11ReportSection14Resource.section?.[0]) {
                if (m11ReportSection14Resource.section[0].text?.div &&
                    m11ReportSection14Resource.section[0].text.status !== "empty") {
                    startingData.section14Status = m11ReportSection14Resource.section[0].text.status;
                    startingData.section14Xhtml = m11ReportSection14Resource.section[0].text.div;
                }
                setSection14State(startingData);
                setStartingSection14State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection14Resource]);

    return <div>
        <h3>Complete Section 14 References</h3>
        {!(m11ReportSection14Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {section14State.loaded && <>
            <h4 style={{ marginBottom: "0px" }}>Revise the Section 14 APPENDIX: REFERENCES summary as needed.</h4>
            <TextDivEntry elementName="section14Xhtml"
                startingValue={section14State.section14Xhtml}
                setResourceState={setSection14State} />
        </>}
    </div >
});

const M11Step040ReferencesHelperText = <div>
    <h3>Complete Section 14 References</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 14 APPENDIX: REFERENCES.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>References should be listed in a common format that includes all relevant information to identify the source and date published. If a reference is not published, this should be clearly indicated.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step040ReferencesValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 40, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 40 (Complete Section 14 References) {validationCheckState.step40numberOfChecks} issues checked. {validationCheckState.step40numberPassed} passed. {validationCheckState.step40numberFailed} failed.</h4>
        <p>Section 14 heading is 'APPENDIX: REFERENCES': {validationCheckState.resultCheckSection14Heading}</p>
        <p>Section 14 APPENDIX: REFERENCES has content: {validationCheckState.resultCheckSection14Content}</p>
    </div>}  </div>
}

export default M11Step040References;
export { M11Step040ReferencesHelperText, M11Step040ReferencesValidationCheck };